import { UiToast } from 'components';
import { formatStr, reload, getRangeNum } from 'lib/utils';
import getGeetestData from 'lib/geetest';
import assign from 'lodash/assign';
import { amber, cryolite } from 'lib/request';
import browser from 'lib/browser';
import { getUserUrl, openWindow, getMainUrl, redirectUrl } from 'lib/base';
import config from 'lib/config';
import redirectRoom from 'modules/baidu/redirect-room';
import Router from 'next/router';
import storage from 'lib/storage';
import track from 'lib/track';
import { globalStore } from 'stores';
import appClient from 'lib/app-client';
import user from './base';
import refreshToken from './refresh-token';

const { saveToken, loadUserInfo } = user;

const onLoginSuccess = (res, redirectPath, onSuccess, loginType) => {
  if (onSuccess) {
    const successRes = onSuccess(res);
    track.send({
      event: 'userLogin',
      event_type: 'onLoginSuccess_onSuccess',
      content: { loginType, successRes },
    });
    if (successRes === false) {
      return;
    }
  }

  if (res && res.data && res.data.access_token) {
    track.send({
      event: 'userLogin',
      event_type: 'onLoginSuccess',
      content: loginType,
    });

    user.clearUserInfo();
    saveToken(res.data.access_token);
    refreshToken.save(res.data);
  }

  UiToast.loading('登录中...');
  loadUserInfo((userInfo) => {
    UiToast.close();

    // globalStore.setLoginSuccess();

    // 在登录页处理
    // if (window['inPcClient']) {
    //   redirectPath = `${process.env.basePath}/client/${userInfo._id}`;
    //   if (browser.memeClient) {
    //     appClient.redirectRoom(userInfo._id)
    //     window.close();
    //     return;
    //   }
    // }
    // 主播直接跳转到自己的房间
    // if (userInfo.priv === 2) {
    //   appClient.redirectRoom(userInfo._id);
    //   if (browser.memeClient) {
    //     window.close();
    //   }
    //   return;
    // }

    if (location.pathname === '/baidu') {
      redirectRoom();
      return;
    }

    if (browser.memeClient) {
      return;
    }

    if (window.inPcClient) {
      redirectPath = `${process.env.basePath}/client/${userInfo._id}`;
    }

    // 有些状态需要刷新，
    reload({
      pathname: redirectPath,
    });
  });
};

/**
 * 么么账号登录
 * @param userName
 * @param password
 * @param onSuccess
 * @param onFail
 */
const loginMeMe = ({
  userName,
  password,
  scope = 'PC_WEB', // PROM_GUILD
  redirectPath,
  onSuccess,
  onFail,
}) => {
  // UiToast.loading('登录中...')
  getGeetestData(
    'login',
    (geetestData, captchaObj) => {
      // @ts-ignore
      let data = {
        grant_type: 'password',
        username: userName,
        password: MM.common.encryptedDES(password),
        scope, // :'H5'
      };
      data = assign({}, data, geetestData);
      amber
        .post({
          url: `api/v3/oauth2/token`,
          // contentType: 'JSON',
          data,
          trackOpt: {
            event: 'userLogin',
            event_type: 'loginMeMe',
          },
        })
        .then((res: any) => {
          // 登录成功
          // UiToast.loading('登录成功')
          captchaObj.reset();

          onLoginSuccess(res, redirectPath, onSuccess, '么么账号登录');
        })
        .catch((res) => {
          // 登录失败
          // UiToast.close()
          captchaObj.reset();
          const tips = {
            30402: '用户名或密码错误，超过5次错误，对应账号将被冻结',
            30403: '密码输入错误过多，账号已被冻结，请30分钟后重试',
            30404: '账号已被临时冻结，请稍后再试，若有疑议，请联系客服',
            1506: '登录受限，请联系客服',
          };
          const msg = tips[res.code] || res.msg || '登录失败，请重试';

          onFail && onFail(msg);
        });
    },
    () => {
      onFail && onFail('极验证失败，请重试');
    },
    () => {
      onFail && onFail('已取消验证');
      // UiToast.close()
    },
  );
};

/**
 * 手机登录
 * @param mobile
 * @param sms_code
 * @param redirectPath
 * @param onSuccess
 * @param onFail
 */
const loginMobile = ({ mobile, sms_code, redirectPath, onSuccess, onFail }) => {
  amber
    .post({
      url: 'api/v2/oauth2/quick_login',
      contentType: 'JSON',
      data: {
        mobile,
        sms_code,
        event_seq_id: Date.now(),
        terminal_type: 'PC_WEB',
        promoter_id: '',
        package_id: '',
        // "prom_guild_id": query.guild_id,
        // "prom_friend_invite_id": query.star_id
      },
      trackOpt: {
        event: 'userLogin',
        event_type: 'loginMobile',
      },
    })
    .then((res: any) => {
      if (res.accounts?.length > 1) {
        onSuccess(res);
      } else {
        onLoginSuccess(res, redirectPath, onSuccess, '手机登录');
      }
    })
    .catch((res) => {
      onFail(res);
    });
};

const loginMobileSelect = ({ data, redirectPath, onSuccess, onFail }) => {
  amber
    .post({
      url: 'api/v1/oauth2/account_login',
      contentType: 'JSON',
      data: {
        tuid: data.tuid,
        select_key: data.select_key,
        event_seq_id: Date.now(),
        terminal_type: 'PC_WEB',
        promoter_id: '',
        package_id: '',
        // "prom_guild_id": query.guild_id,
        // "prom_friend_invite_id": query.star_id
      },
      trackOpt: {
        event: 'userLogin',
        event_type: 'loginMobileSelect',
      },
    })
    .then((res) => {
      onLoginSuccess(res, redirectPath, onSuccess, '手机登录');
    })
    .catch((res) => {
      onFail(res.msg);
    });
};

const loginMobileCheck = ({ mobile, sms_code, redirectPath, onSuccess, loginRes, onFail }) => {
  amber
    .post({
      url: 'api/v2/verify_code',
      contentType: 'JSON',
      data: {
        mobile,
        sms_code,
        sms_type: 'mobile_login',
      },
      trackOpt: {
        event: 'userLogin',
        event_type: 'loginMobileCheck',
      },
    })
    .then((res) => {
      onLoginSuccess(loginRes, redirectPath, onSuccess, '手机登录验证');
    })
    .catch((res) => {
      onFail(res.msg);
    });
};

const setLoginBackRoute = () => {
  const { query = {}, pathname, asPath } = Router.router!;
  query.redirect_from = 'thirdLogin';
  storage.setItem('LOGIN_BACK_ROUTE', { query, pathname, asPath });
};

type LoginType = 'wechat' | 'qq' | 'sina';

const redirectThirdLogin = (urlType: LoginType) => {
  setLoginBackRoute();

  track.send({
    event: 'userLogin',
    event_type: 'redirectThirdLogin',
    content: urlType,
  });

  let backUrl = `${appClient.getPageUrl('/login')}?login_type=${urlType}&ticket={access_token}`;

  if (browser.memeClient) {
    // 为了匹配 URLPattern 模式，自定义一个标准的域名，然后在主进程中做拦截
    // https://developer.mozilla.org/en-US/docs/Web/API/URLPattern/test
    // https://developer.mozilla.org/en-US/docs/Mozilla/Add-ons/WebExtensions/Match_patterns
    backUrl = `http://memeliveclient.com/login?ticket={access_token}`;
  }

  backUrl = encodeURIComponent(backUrl);

  const urlConfig = {
    wechat: {
      getLoginUrl: () => {
        const redirectUrl = formatStr(getUserUrl(config.weixinApi), {
          appid: config.wxAppId,
        });
        const loginUrl = formatStr(config.weixinLoginUrl as string, {
          appid: config.wxAppId,
        });

        return formatStr(loginUrl, {
          redirect_uri: encodeURIComponent(
            `${redirectUrl + (redirectUrl.indexOf('?') > -1 ? '&' : '?')}url=${backUrl}`,
          ),
        });
      },
    },
    qq: {
      getLoginUrl: () => {
        const redirectUrl = getUserUrl(config.qqApi);

        return formatStr(config.qqLoginUrl, {
          redirect_uri: encodeURIComponent(
            `${redirectUrl + (redirectUrl.indexOf('?') > -1 ? '&' : '?')}url=${backUrl}`,
          ),
        });
      },
    },
    sina: {
      getLoginUrl: () => {
        const redirectUrl = getUserUrl(config.sinaApi);

        return formatStr(config.sinaLoginUrl, {
          redirect_uri: encodeURIComponent(redirectUrl),
          state: backUrl,
        });
      },
    },
  };

  // if (config.production ) {
  //     urlType = 'weixin';
  // }

  const openUrl = urlConfig[urlType].getLoginUrl();

  if (browser.memeClient) {
    // location.href = openUrl;
    redirectUrl(openUrl, true, {
      width: 783,
      height: 466,
      isModal: true,
      isClientWebView: true,
    });
  } else {
    const win = openWindow(openUrl);
    if (win && win.focus) {
      win.focus();
    }
  }
};

const redirectQQLogin = () => {
  redirectThirdLogin('qq');
};

const redirectWechatLogin = () => {
  redirectThirdLogin('wechat');
};
const redirectWeiboLogin = () => {
  redirectThirdLogin('sina');
};

const loginSuccessCallback = () => {
  if (location.pathname === '/baidu') {
    redirectRoom();
    return;
  }

  UiToast.success('登录成功，跳转中...');
  location.reload();
};

if (typeof window !== 'undefined') {
  // @ts-ignore
  window.loginSuccessCallback = loginSuccessCallback;
}

const register = ({ mobile, pwd, sms_code, redirectPath, onSuccess, onFail }) => {
  amber
    .post({
      url: 'api/v1/registers/mobile',
      contentType: 'JSON',
      data: {
        mobile,
        pwd,
        sms_code,
        terminal_type: 'PC_WEB',
        event_seq_id: Date.now(),
      },
      trackOpt: {
        event: 'userLogin',
        event_type: 'register',
      },
    })
    .then((res) => {
      onLoginSuccess(res, redirectPath, onSuccess, '手机登录');
    })
    .catch((res) => {
      onFail(res.msg);
    });
};

export default {
  loginMobile,
  loginMobileSelect,
  loginMobileCheck,
  loginMeMe,
  redirectWeiboLogin,
  redirectQQLogin,
  redirectWechatLogin,
  redirectThirdLogin,
  onLoginSuccess,
  register,
};
